import { Injectable } from '@angular/core';

import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private signalRSource = new Subject<string>();
  signalR$ = this.signalRSource.asObservable();

  public hubConnection!: HubConnection;

  public init({ uri, accessToken }: { uri: string; accessToken: string }) {
    this.createConnection(uri, accessToken);

    return this.startConnection()
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  public createConnection(url: string, accestoken: string) {    
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(url, { accessTokenFactory: () => accestoken })
      .configureLogging(signalR.LogLevel.Information)
      .build();
    
    this.hubConnection.onclose((err: any) => {});
  }

  public startConnection(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      console.log('1. startConnection => ');
      this.hubConnection
        .start()
        .then(() => {
          console.log('2. startConnection => ');
          this.subscribeToServerEvents();
          resolve(true);
          console.log('3. startConnection => ');
        })
        .catch((err: any) => {
          console.log('4. startConnection => ');
          reject(false);
        });
    });
  }

  public subscribeToServerEvents(): void {
    console.log('Entro =>', 'subscribeToServerEvents');
    this.hubConnection.on('NOTIFICATION_TRAY', (data: any) => {
      console.log('NOTIFICATION_TRAY =>', data);
      if (data.title === 'TRANSACTION_FINISHED') {
        this.signalRSource.next(data.transactionId);
      }
    });
  }
}
